import EsfirusButtonNative from '@components/ui/Button/EsfirusButtonNative';
import { getAvailableCompanies } from '@helpers/companyData';
import { partesService } from '@services/partes';
import {
  resetPartes,
  setSelectedDateFrom,
  setSelectedDateTo,
  setSelectedEmpleado,
  setSelectedEmpresa,
  setSelectedObra,
  setSelectedResponsable,
  resetProperty
} from '@store/slices/partes';
import EsfirusSearch from '@ui/Search/EsfirusSearch';
import EsfirusSelect from '@ui/Select/EsfirusSelect';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from '@services/hooks/redux-hooks';
import ModalMsg from '../modalMsg/ModalMsg';
import './subheader.scss';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import 'dayjs/locale/es';

import EsfirusTextInput from '@components/ui/Text-input/EsfirusTextInput';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import usePartesGet from '@services/hooks/usePartesGet';
import ModalValidating from '../ModalValidating/ModalValidating';
import { setTableFilters, TABLE_PARTES_VALIDATING_ID } from '@store/slices/tableFilters';
import { delay } from '@helpers/utils';

function PartesSubHeader(props: any) {
  const getPartes = usePartesGet();

  const empresas = useSelector(state => state.empresas.list);
  const obras = useSelector(state => state.obras.list);
  const filterByType = useSelector(state => state.partes.filterByType);
  const customFilters = useSelector(state => state.tableFilters[TABLE_PARTES_VALIDATING_ID]);

  const dispatch = useDispatch();

  const [empresasDisponibles, setEmpresasDisponibles] = useState<any>([]);
  const [empresasList, setEmpresasList] = useState<any>([]);
  const [obrasList, setObrasList] = useState<any>([]);
  const [msg, setMsg] = useState<any>('');
  const [open, setOpen] = useState<any>(false);

  const [isValidating, setIsValidating] = useState(false); // Para saber si se está validando el parte
  const [showModalValidating, setShowModalValidating] = useState(false); // Para mostrar el modal de validando un parte

  const partesLength = useMemo(
    () => props?.partes?.length ?? 0,
    [props?.partes]
  );
  const pendingSelectedLength = useMemo(
    () =>
      Object.values(props?.pendingSelected ?? {}).filter((val) => !!val)
        ?.length,
    [props?.pendingSelected]
  );

  const employeesOptions = useMemo(() => {
    return props?.empleadosList.map((empleado: any) => {
      const { internal = [] } = empleado.data;
      const idInternalEmpresa = internal?.[0].empresa
      const empresaObject = empresas.find((empresa: any) => idInternalEmpresa == empresa.Empresa);

      const label = `${empleado.nombre} ${empleado.apellidos} - ${empresaObject?.Nombre}`;
      const value = empleado.id;

      return ({
        label,
        value,
      })
    });
  }, [props?.empleadosList, empresas]);

  const responsiblesOptions = useMemo(() => {
    return props?.responsablesList.map((empleado: any) => {
      const { internal = [] } = empleado.data;
      const idInternalEmpresa = internal?.[0].empresa
      const empresaObject = empresas.find((empresa: any) => idInternalEmpresa == empresa.Empresa);

      const label = `${empleado.nombre} ${empleado.apellidos} - ${empresaObject?.Nombre}`;
      const value = empleado.id;

      return ({
        label,
        value,
      })
    });
  }, [props?.responsablesList, empresas]);

  useEffect(() => {
    setEmpresasDisponibles(getAvailableCompanies());
    // selectEmpresa(getInternalCompany());
    setObrasList(obras);
  }, []);

  useEffect(() => {
    setEmpresasList(
      empresas.filter(
        (e: any) =>
          empresasDisponibles === '*' || empresasDisponibles.includes(e.Empresa)
      )
    );
  }, [empresasDisponibles]);

  const setFilters = (filters = {}) => {
    dispatch(
      setTableFilters(
        {
          tableId: TABLE_PARTES_VALIDATING_ID,
          filters: {
            ...customFilters,
            selectedFilters: {
              ...customFilters?.selectedFilters,
              ...filters,
            }
          }
        }
      )
    );
  }

  const selectEmpresa = (empresa: any) => {
    //deseleccionamos la obra si estubiera filrada
    setFilters({ empresa, obra: null, empleado: null, responsable: null });
    setObrasList(empresa
      ? obras.filter((e: any) => e.Empresa === empresa)
      : obras.filter((e: any) => e.Empresa)
    );
  };

  const updatePromise = () => dispatch(getPartes({ offset: 0, limit: 50, estado: filterByType, filtersValidating: customFilters?.selectedFilters ?? {} } as any) as any);

  const hasPartesSelected =
    Object.entries(props.pendingSelected).filter((e: any) => e[1]).length > 0;

  const handleValidateSelection: VoidFunction = async () => {
    setShowModalValidating(true);
    setIsValidating(true);

    try {
      const { pendingSelected } = props;
      const allTrue = Object.values(pendingSelected).every(Boolean);
      const forValidate = Object.keys(pendingSelected).filter(
        (key) => pendingSelected[key]
      );

      if (forValidate.length === 0) {
        setIsValidating(false);
        return;
      }

      for (const id of forValidate) {
        await partesService.confirmarParte(id)
        await delay(500); // Esperar medio segundo entre cada validación para evitar problemas de concurrencia (Solución temporal)
      }

      await updatePromise();

      if (allTrue || pendingSelectedLength >= partesLength) {
        dispatch(resetPartes({} as any));
      }

      setOpen(false);
    } catch (error) {
      console.error('Error en la validación:', error);
    } finally {
      setIsValidating(false);
    }
  };

  return (
    <div className="ef-pates-subheader">
      <div className="ef-left">
        <EsfirusSelect
          key={'ef-select-company'}
          options={empresasList.map((e: any) => ({
            label: e.Nombre,
            value: e.Empresa,
          }))}
          value={customFilters?.selectedFilters?.empresa}
          change={(e: any) => {
            if (e === '') {
              selectEmpresa(null as never);
            } else {
              selectEmpresa(
                empresas.find(
                  (_e: any) => _e.Empresa.toString() === e.toString()
                )?.Empresa ?? null
              );
            }
          }}
          placeholder="Todas"
        />

        <EsfirusSelect
          style={{ maxWidth: window.innerWidth > 500 ? '500px' : '0px' }}
          key={'ef-select-obra'}
          options={obrasList.map((e: any) => ({
            label: e.Obra + ' - ' + e.Descripcion,
            value: e.Obra,
          }))}
          value={customFilters?.selectedFilters?.obra}
          change={(e: any) => {
            if (e === '') {
              setFilters({ obra: null });
            } else {
              setFilters({ obra: obras.find((_e: any) => _e.Obra === +e)?.Obra });
            }
          }}
          placeholder="Obra"
        />

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <DatePicker
            value={customFilters?.selectedFilters?.dateFrom as any}
            onChange={(newValue) => {
              if (!newValue) {
                setFilters({ dateFrom: null });
                return
              }
              const date = new Date(newValue.$y, newValue.$M, newValue.$D);
              setFilters({ dateFrom: date?.getTime() });
            }}
            renderInput={(params) => <EsfirusTextInput ref={params.inputRef} fullWidth {...params} />}
            inputFormat="DD/MM/YYYY"
            className="datePickerFilter"
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <DatePicker
            value={customFilters?.selectedFilters?.dateTo as any}
            onChange={(newValue) => {
              if (!newValue) {
                setFilters({ dateTo: null });
                return
              }
              const date = new Date(newValue.$y, newValue.$M, newValue.$D);
              setFilters({ dateTo: date?.getTime() });
            }}
            renderInput={(params) => <EsfirusTextInput ref={params.inputRef} fullWidth {...params} />}
            inputFormat="DD/MM/YYYY"
            className="datePickerFilter"
          />
        </LocalizationProvider>

        <EsfirusSearch
          value={customFilters?.searchQuery}
          change={(e: any) => dispatch(setTableFilters({ tableId: TABLE_PARTES_VALIDATING_ID, filters: { ...customFilters, searchQuery: e } }))}
          placeholder="Buscar"
        />

        <EsfirusSelect
          key={'ef-select-employee'}
          options={employeesOptions}
          value={customFilters?.selectedFilters?.empleado}
          change={(e: any) => {
            if (e === '') {
              setFilters({ empleado: null });
            } else {
              setFilters({ empleado: e });
            }
          }}
          placeholder="Todos los Empleados"
        />

        <EsfirusSelect
          key={'ef-select-responsable'}
          options={responsiblesOptions}
          value={customFilters?.selectedFilters?.responsable}
          change={(e: any) => {
            if (e === '') {
              setFilters({ responsable: null });
            } else {
              setFilters({ responsable: e });
            }
          }}
          placeholder="Todos los Responsables"
        />

        <label className="containerCheckbox">
          <input
            type="checkbox"
            checked={Boolean(customFilters?.selectedFilters?.attach)}
            onChange={(e: any) => setFilters({ attach: e.target.checked })}
            disabled={false}
          />
          <span className="checkmark"></span>
          Mostrar partes con adjuntos
        </label>
      </div>
      <div className="ef-right">
        <EsfirusButtonNative
          className={'validate'}
          label={'Validar selección'}
          disabled={!hasPartesSelected}
          click={handleValidateSelection}
        ></EsfirusButtonNative>
        <EsfirusButtonNative
          className={'rejected'}
          label={'Rechazar selección'}
          disabled={!hasPartesSelected}
          click={() => {
            setMsg('');
            setOpen(true);
          }}
        ></EsfirusButtonNative>
      </div>
      <ModalMsg
        open={open}
        setOpen={setOpen}
        onMsg={(m: string) => {
          setMsg(m);
        }}
        onSave={async () => {
          const paraRechazar = Object.entries(props.pendingSelected).filter(
            (e: any) => e[1]
          );
          const promises = paraRechazar.map((p: any) =>
            partesService.rechazarParte(p[0], msg)
          );
          await Promise.all(promises);
          await updatePromise();
          if (pendingSelectedLength >= partesLength) {
            dispatch(resetPartes({} as any));
          }
          setOpen(false);
        }}
      ></ModalMsg>

      {showModalValidating && (
        <ModalValidating
          open={showModalValidating}
          setOpen={setShowModalValidating}
          isValidating={isValidating}
        />
      )}
    </div>
  );
}

export default PartesSubHeader;
